import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=063de322&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=063de322&scoped=true&lang=css&"
import style1 from "./Layout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063de322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063de322')) {
      api.createRecord('063de322', component.options)
    } else {
      api.reload('063de322', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=063de322&scoped=true&", function () {
      api.rerender('063de322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Layout.vue"
export default component.exports